import { render, staticRenderFns } from "./ProductButton.vue?vue&type=template&id=5dacad18&"
import script from "./ProductButton.vue?vue&type=script&lang=js&"
export * from "./ProductButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\dev.marcdeloche.fr\\themes\\marcdeloche\\_dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5dacad18', component.options)
    } else {
      api.reload('5dacad18', component.options)
    }
    module.hot.accept("./ProductButton.vue?vue&type=template&id=5dacad18&", function () {
      api.rerender('5dacad18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vuejs/components/Product/Wishlist/ProductButton.vue"
export default component.exports